export default "__VITE_ASSET__CjbESSga__"